import { api } from "./axios";
import { AuthUser } from "@/store/auth.store";

interface Envelope<T> {
  success: true;
  data: T;
}

export interface LoginResponse {
  user: AuthUser;
  accessToken: string;
}

export const authApi = {
  async login(email: string, password: string): Promise<LoginResponse> {
    const res = await api.post<Envelope<LoginResponse>>("/auth/login", { email, password });
    return res.data.data;
  },

  async logout(): Promise<void> {
    await api.post("/auth/logout");
  },

  async forgotPassword(email: string): Promise<{ message: string }> {
    const res = await api.post<Envelope<{ message: string }>>("/auth/forgot-password", { email });
    return res.data.data;
  },

  async resetPassword(token: string, newPassword: string): Promise<{ message: string }> {
    const res = await api.post<Envelope<{ message: string }>>("/auth/reset-password", {
      token,
      newPassword,
    });
    return res.data.data;
  },

  async changePassword(
    currentPassword: string,
    newPassword: string
  ): Promise<{ accessToken: string; message: string }> {
    const res = await api.post<Envelope<{ accessToken: string; message: string }>>(
      "/auth/change-password",
      { currentPassword, newPassword }
    );
    return res.data.data;
  },

  async me(): Promise<AuthUser> {
    const res = await api.get<Envelope<AuthUser>>("/auth/me");
    return res.data.data;
  },
};
